import { useField, useFormikContext } from 'formik';
import { TextField, useTheme } from "@mui/material";

const TimeInput = ({ label, ...props }) => {
  const theme = useTheme();
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <TextField
      type="time"
      label={label}
      size="small"
      fullWidth
      margin="normal"
      value={field.value || ''}
      onChange={(e) => setFieldValue(field.name, e.target.value)}
      error={meta.touched && Boolean(meta.error)}
      helperText={meta.touched && meta.error ? meta.error : ''}
      InputLabelProps={{ shrink: true }}
      sx={{
        mt: 2,
        '& .MuiInputBase-input': {
          color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
          fontWeight: 400,
        },
        '& .MuiInputLabel-root': {
          color: theme.palette.text.secondary,
          fontWeight: 400,
          fontSize: '0.9rem',
        },
        '& .MuiOutlinedInput-root': {
          backgroundColor: theme.palette.background.default,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[900],
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[900],
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[900],
            borderWidth: 2,
          },
        },
      }}
    />
  );
};

export default TimeInput;
